export enum LabelEnum {
  EXAMPLE = "example",
}

export interface Label {
  key: LabelEnum;
  value: string;
}
